import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemInformationRewardsComponent } from '../item-information-rewards/item-information-rewards.component';
import { RewardsDataService } from '../../services/rewards-data.service';
import { TranslateModule } from '@ngx-translate/core';
import { ApiService, UserInfo } from 'app/services/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-table-information-rewards',
  standalone: true,
  imports: [CommonModule, ItemInformationRewardsComponent, TranslateModule],
  templateUrl: './table-information-rewards.component.html',
  styleUrls: ['./table-information-rewards.component.scss'],
})
export class TableInformationRewardsComponent implements OnInit {
  @Input() eliteStatus!: string;
  @Input() countryWarehouse!: string;
  @Output() itemClicked = new EventEmitter<any>();
  items: any[] = [];
  userInfo: UserInfo;

  constructor(private router: Router, 
              private api: ApiService, 
              private rewardsService: RewardsDataService) {}

  ngOnInit(): void {
    this.rewardsService.getRewardsItems().subscribe(data => {
      this.items = data;
    });

    this.api.userInfo.subscribe((userInfo) => {
        this.userInfo = userInfo
    });
  }

  handleItemClick(item: any) {
    console.log('---- ITEM - ' + item.code_link);
    let option = item?.code_link;

    if (option) {
      let currentItem = this.userInfo.mainMenu.items.find((item) => item.code === option);
      switch (item.code_link) {
        case 'e-cosentino':
          console.log('Has hecho clic en ', option);
          if (currentItem?.link) window.open(currentItem.link, '_blank');
          break;
        case 'my-financial-portal':
          console.log('Has hecho clic en ', option);
          if (currentItem?.link) window.open(currentItem.link, '_blank');
          break;
        case 'my-claims':
          console.log('Has hecho clic en ', option);
          this.router.navigate(['/my-claims']);
          break;
        case 'we_promote':
          console.log('Has hecho clic en ', option ?? 'valor no definido');
          break;
        case 'we_cosentino_events':
          console.log('Has hecho clic en ', option ?? 'valor no definido');
          break;
        default:
          console.log('Has hecho clic en ', option ?? 'valor no definido');
      }
    }
    //this.itemClicked.emit(item);
  }

  goToEConsentino() {
    let item = this.userInfo.mainMenu.items.find((item) => item.code === 'e-cosentino');
    //if (item?.link) window.open(item.link, '_blank');
  }
}
